const React = require('react');
const loadNotFoundPage = require('../../actions').loadNotFoundPage;
const executeLoadActions	 = require('../../addons/executeLoadActions');
class NotFoundHandler extends React.Component {
	render() { return (<noscript/>); }
}
NotFoundHandler.handlerActions = [loadNotFoundPage];
NotFoundHandler.contextTypes = { store: React.PropTypes.object };

module.exports = executeLoadActions(NotFoundHandler);




/** WEBPACK FOOTER **
 ** ./app/components/NotFoundHandler/index.js
 **/